module.exports = __webpack_public_path__ + "static/img/catalogBg.846dc9ba.png";